var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLocked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "light_mode / icons / icon_locked") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "light_mode-/-icons-/-icon_locked"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99996596,0 C10.0735416,0 11.7529013,1.70570571 11.7529013,3.81181181 L11.7529013,3.81181181 L11.7529013,5.33333333 L12.5097958,5.33333333 C13.3297649,5.33333333 14.0078162,6.02202202 13.9999319,6.85485485 L13.9999319,6.85485485 L13.9999319,14.4784785 C13.9999319,15.3113113 13.3297649,16 12.5019115,16 L12.5019115,16 L3.49802041,16 C2.67805134,16 2,15.3193193 2,14.4784785 L2,14.4784785 L2,6.85485485 C2,6.02202202 2.67016703,5.33333333 3.49802041,5.33333333 L3.49802041,5.33333333 L4.24703062,5.33333333 L4.24703062,3.81181181 C4.24703062,1.70570571 5.92639034,0 7.99996596,0 Z M8.00785028,9.14514515 C7.18788121,9.14514515 6.50982987,9.83383383 6.50982987,10.6666667 C6.50982987,11.4994995 7.1799969,12.1881882 8.00785028,12.1881882 C8.82781935,12.1881882 9.50587069,11.4994995 9.50587069,10.6666667 C9.50587069,9.83383383 8.82781935,9.14514515 8.00785028,9.14514515 Z M8.00785028,1.44944945 C6.72270646,1.44944945 5.68197649,2.50650651 5.68197649,3.81181181 L5.68197649,3.81181181 L5.68197649,5.33333333 L10.3337241,5.33333333 L10.3337241,3.81181181 C10.3337241,2.50650651 9.29299411,1.44944945 8.00785028,1.44944945 Z",
    id: "Combined-Shape",
    fill: "#51575C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocked);
export default __webpack_public_path__ + "static/media/icon_locked.e21fa61602ca7e1bd7d4bbfb192f0dee.svg";
export { ForwardRef as ReactComponent };